// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3ZYpo","title":"FrontImage_title__2aUhx"};